export const IsNullOrEmpty = (value: any) => {
  if(value === '' || value === null || value === undefined) return true;

  return false;
}